import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RecentSearchService } from '@services/recent-search.service';
import { PageLinkService } from '@spartacus/core';
import { CategoryNavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-category-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './custom-category-navigation.component.html',
  styleUrl: './custom-category-navigation.component.scss',
})
export class CustomCategoryNavigationComponent extends CategoryNavigationComponent {
  recentSearchService = inject(RecentSearchService);
  pageService = inject(PageLinkService);

  hoveredIndex = -1;
  baseLeft = 0;

  handleFocus(index: number) {
    this.hoveredIndex = index;
  }

  setPreviousQuery(url: string | string[]): void {
    if (!url) {
      return;
    }

    const firstUrl = Array.isArray(url) ? url[0] : url;
    this.recentSearchService.setRecentSearch(firstUrl);
  }
}
